import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ConfirmModalOptions } from 'src/app/models/utils/confirm-modal.model';
import { ConfirmModalComponent } from 'src/app/shared/components/modals/confirm-modal/confirm-modal.component';

@Injectable({
	providedIn: 'root',
})
export class ConfirmModalService {
	constructor(private ngbModal: NgbModal) {}

	open(container: string, options: ConfirmModalOptions): Observable<boolean> {
		const modalRef = this.ngbModal.open(ConfirmModalComponent, {
			container: container,
			centered: true,
			size: 'xl',
			backdrop: 'static',
			keyboard: false,
		});
		this.addOptionsToComponent(modalRef, options);
		return modalRef.closed;
	}

	private addOptionsToComponent(
		modalRef: NgbModalRef,
		options: ConfirmModalOptions
	) {
		const confirmModal = modalRef.componentInstance as ConfirmModalComponent;
		confirmModal.btnText = options.buttonText;
		confirmModal.modalText = options.message;
	}
}
